import commonReducer from '../reducers/commonReducer';
import quartzReducer from '../reducers/quartzReducer';
import semaphoreLocksReducer from '../reducers/semaphoreLocksReducer';


const rootReducer = () => ({
    common: commonReducer,
    quartz: quartzReducer,
    semaphoreLocks: semaphoreLocksReducer
});


export default rootReducer;